(function () {
  if (window.customElements && customElements.get('alia-header')) return;

  var OPEN_DELAY = 90;   // hover-intent before opening
  var CLOSE_DELAY = 160; // grace so the pointer can reach the panel

  class AliaHeader extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      // 1. FIRST PAINT: the server-rendered shadow root (declarative, or built here from the
      //    <template> if the browser didn't parse it) shows the bar instantly.
      var pre = this.shadowRoot;
      if (!pre) {
        var tpl = null;
        for (var c = this.firstElementChild; c; c = c.nextElementSibling) { if (c.tagName === 'TEMPLATE') { tpl = c; break; } }
        if (!tpl) return;
        pre = this.attachShadow({ mode: 'open' });
        pre.appendChild(tpl.content.cloneNode(true));
        tpl.parentNode.removeChild(tpl);
      }
      var preHdr = pre.querySelector('[data-hdr]');

      // 2. THE LIVE HEADER: bar + dropdown + drawer + search + dimmer in ONE shadow host that sits
      //    directly on <body>. Nothing in the page can clip, transform, restyle or offset it, and
      //    no page CSS/JS can reach inside.
      var owner = this.dataset.sectionId || '';
      Array.prototype.slice.call(document.querySelectorAll('alia-shell')).forEach((n) => {
        if (n.getAttribute('data-owner') === owner) n.parentNode.removeChild(n);   // stale copy from a previous render
      });
      this.shell = document.createElement('alia-shell');
      this.shell.setAttribute('data-owner', owner);
      this.shell.style.cssText = 'display:block;height:0;overflow:visible';
      this.sroot = this.shell.attachShadow({ mode: 'open' });
      var link = null;
      Array.prototype.slice.call(pre.querySelectorAll('style, link[rel="stylesheet"]')).forEach((n) => {
        var cl = n.cloneNode(true);
        if (n.tagName === 'LINK') { link = cl; cl.removeAttribute('onload'); }
        this.sroot.appendChild(cl);
      });
      this.hdr = preHdr.cloneNode(true);
      this.sroot.appendChild(this.hdr);
      this.bar = this.hdr.querySelector('[data-bar]');
      this.mega = pre.querySelector('[data-mega]');
      this.drawer = pre.querySelector('[data-drawer]');
      this.scrim = pre.querySelector('[data-scrim]');
      this.search = pre.querySelector('[data-search]');
      [this.mega, this.scrim, this.search, this.drawer].forEach((el) => { if (el) this.sroot.appendChild(el); });
      document.body.appendChild(this.shell);

      // 3. Swap: once the live copy's stylesheet is ready, show it and drop the first-paint copy in
      //    the same task, so there is no flash and no jump.
      var reveal = () => {
        if (this._revealed) return;
        this._revealed = true;
        if (this._ready) { this._recheck = true; this.measure(); }
        this.shell.setAttribute('data-ready', '');
        this.setAttribute('data-ready', '');
        if (preHdr.parentNode) preHdr.parentNode.removeChild(preHdr);
      };
      if (link) { link.addEventListener('load', reveal); link.addEventListener('error', reveal); }
      setTimeout(reveal, 1200);
      if (!link) reveal();

      this.themeSync = this.dataset.themeSync !== 'false';
      this.openOn = this.dataset.openOn === 'click' ? 'click' : 'hover';
      this.smartHide = this.dataset.smartHide === 'true';
      this.megaAlign = this.dataset.megaAlign === 'center' ? 'center' : 'item';
      this.annH = 0;

      // Theme sync (optional): body flags the Broadcast theme's own CSS reads.
      if (this.themeSync) {
        document.body.classList.toggle('has-header-sticky', this.dataset.sticky === 'true');
        document.body.classList.toggle('has-header-transparent', this.hasAttribute('data-transparent'));
      } else {
        // ISOLATED MODE: the theme makes .collection__nav / .collection__sidebar__slider sticky at
        // top:var(--header-height) whenever <body> has .has-header-sticky. Our bar is fixed and can
        // smart-hide, which would leave that filter hovering in an empty gap. Strip the hook (and any
        // stale height overrides) so the collection filter stays in normal flow and never floats.
        document.body.classList.remove('has-header-sticky');
        var rs0 = document.documentElement.style;
        ['--HEADER-HEIGHT', '--HEADER-HEIGHT-MEDIUM', '--HEADER-HEIGHT-MOBILE', '--header-height', '--header-sticky-height'].forEach(function (k) { rs0.removeProperty(k); });
      }

      this.items = Array.prototype.slice.call(this.sroot.querySelectorAll('[data-nav-item]'));
      this.box = this.mega ? this.mega.querySelector('[data-box]') : null;
      this.notch = this.mega ? this.mega.querySelector('[data-notch]') : null;
      this.panels = this.mega ? Array.prototype.slice.call(this.mega.querySelectorAll('[data-panel]')) : [];

      this.current = null;
      this.openTimer = null;
      this.closeTimer = null;
      this.lastInput = 'mouse';
      this.lastY = window.scrollY || 0;
      this.ticking = false;

      this.measure = this.measure.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocPointer = this.onDocPointer.bind(this);

      this.compact = false; this.compactW = 0; this._recheck = false;
      this._onLate = () => { this._recheck = true; this.measure(); };
      this.measure();
      this._ready = true;
      window.addEventListener('resize', this.measure, { passive: true });
      window.addEventListener('load', this._onLate);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this._onLate);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('pointerdown', this.onDocPointer, true);

      this.bindNav();
      this.bindDrawer();
      this.bindSearch();
      this.bindMegaHover();

      if (this.scrim) this.scrim.addEventListener('click', () => { this.close(); this.closeDrawer(); this.closeSearch(); });

      this.syncCart();
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.measure);
      window.removeEventListener('load', this._onLate);
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('pointerdown', this.onDocPointer, true);
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      document.body.classList.remove('alia-drawer-open', 'alia-search-open', 'has-header-sticky', 'has-header-transparent');
      var rs = document.documentElement.style;
      ['--alia-top', '--HEADER-HEIGHT', '--HEADER-HEIGHT-MEDIUM', '--HEADER-HEIGHT-MOBILE'].forEach((k) => rs.removeProperty(k));
      if (this.shell && this.shell.parentNode) this.shell.parentNode.removeChild(this.shell);
    }

    /* ---- sizing -------------------------------------------------------- */
    measure() {
      this.fit();
      var h = this.bar ? this.bar.offsetHeight : 64;
      document.documentElement.style.setProperty('--alia-hdr-h', h + 'px');
      this.annH = this.aboveHeight();
      this.setTop();
      if (this.current) { this.setHeight(this.current); this.placeBox(this.current); }
    }

    /* ---- auto mobile layout ------------------------------------------------
       Below 1000px the CSS already shows the mobile bar. Between 1000px and the point where the
       logo + menu + buttons no longer fit, we add .is-compact so the header uses the SAME mobile
       layout (burger, logo, search, cart) instead of letting items overlap. When there is room
       again it switches back. Everything happens in one task, so there is no visible flicker. */
    fit() {
      if (!this.bar || !this._revealed) return;
      if ((window.innerWidth || 0) < 1000) {           // the media query handles phones/tablets
        this.compactW = 0;
        if (this.compact) this.setCompact(false);
        return;
      }
      var w = this.bar.clientWidth || window.innerWidth;
      if (this.compact) {
        if (w <= this.compactW && !this._recheck) return;   // no more room than when we gave up
        this.hdr.classList.remove('is-compact');            // test the desktop layout again
      }
      this._recheck = false;
      var ok = this.desktopFits();
      if (ok) {
        if (this.compact) this.setCompact(false, true);
      } else {
        this.hdr.classList.add('is-compact');
        this.compactW = w;
        if (!this.compact) this.setCompact(true, true);
      }
    }

    setCompact(on, alreadyApplied) {
      this.compact = on;
      if (!alreadyApplied) this.hdr.classList.toggle('is-compact', on);
      if (on) this.close(); else this.closeDrawer();
    }

    // True when the logo, the menu and the buttons all have their own space (nothing touches).
    desktopFits() {
      var inner = this.bar.querySelector('.alia-bar__inner');
      if (!inner) return true;
      if (inner.scrollWidth > inner.clientWidth + 1) return false;
      var box = (r) => ({ left: r.left, right: r.right, top: r.top, bottom: r.bottom });
      var parts = [];
      var logo = inner.querySelector('.alia-logo'), act = inner.querySelector('.alia-bar__actions');
      var lis = inner.querySelectorAll('.alia-nav__item');
      if (logo) parts.push(box(logo.getBoundingClientRect()));
      if (lis.length) {
        var a = lis[0].getBoundingClientRect(), z = lis[lis.length - 1].getBoundingClientRect();
        parts.push({ left: Math.min(a.left, z.left), right: Math.max(a.right, z.right), top: Math.min(a.top, z.top), bottom: Math.max(a.bottom, z.bottom) });
      }
      if (act) parts.push(box(act.getBoundingClientRect()));
      var gap = 8;
      for (var i = 0; i < parts.length; i++) {
        for (var k = i + 1; k < parts.length; k++) {
          var p = parts[i], q = parts[k];
          if (p.right - p.left <= 0 || q.right - q.left <= 0) continue;
          var across = p.right + gap > q.left && q.right + gap > p.left;
          var down = p.bottom > q.top && q.bottom > p.top;
          if (across && down) return false;
        }
      }
      return true;
    }

    // Height of sections rendered above the header (e.g. the announcement bar).
    aboveHeight() {
      var wrap = this.closest('.shopify-section');
      var off = 0;
      var sib = wrap ? wrap.previousElementSibling : null;
      while (sib) { off += sib.offsetHeight || 0; sib = sib.previousElementSibling; }
      return off;
    }

    // While the bar is slid away, tell the theme its header is 0px tall, so the theme's own
    // sticky bits (e.g. the collection filter bar) don't hover in an empty gap.
    syncTheme() {
      if (!this.themeSync) return;
      var hidden = this.hdr.classList.contains('is-hidden');
      var rs = document.documentElement.style;
      ['--HEADER-HEIGHT', '--HEADER-HEIGHT-MEDIUM', '--HEADER-HEIGHT-MOBILE'].forEach((k) => {
        if (hidden) rs.setProperty(k, '0px'); else rs.removeProperty(k);
      });
    }

    // The fixed bar rides just under the announcement bar until it scrolls away.
    setTop() {
      var y = window.scrollY || 0;
      document.documentElement.style.setProperty('--alia-top', Math.max(0, (this.annH || 0) - y) + 'px');
    }

    /* ---- scroll: solid state + smart hide ------------------------------ */
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        var y = window.scrollY || 0;
        this.setTop();
        this.hdr.classList.toggle('is-scrolled', y > 8);
        if (this.smartHide) {
          if (this.current || this.drawerOpen || y < 120) this.hdr.classList.remove('is-hidden');
          else if (y > this.lastY + 4) { this.hdr.classList.add('is-hidden'); this.close(); }
          else if (y < this.lastY - 4) this.hdr.classList.remove('is-hidden');
          if (this.mega) this.mega.classList.toggle('is-hidden-bar', this.hdr.classList.contains('is-hidden'));
          this.syncTheme();
        }
        this.lastY = y;
        this.ticking = false;
      });
    }

    onKeydown(e) {
      if (e.key !== 'Escape') return;
      if (this.searchOpen) { this.closeSearch(); return; }
      if (this.drawerOpen) { this.closeDrawer(); return; }
      if (this.current) {
        var item = this.current;
        this.close();
        var t = item.querySelector('.alia-nav__link');
        if (t) t.focus();
      }
    }

    onDocPointer(e) {
      if (!this.current) return;
      var path = e.composedPath ? e.composedPath() : [e.target];
      if (this.shell && path.indexOf(this.shell) > -1 && path.indexOf(this.scrim) === -1) return;   // inside the header (the dimmer itself closes it)
      this.close();
    }

    /* ---- desktop nav --------------------------------------------------- */
    bindNav() {
      this.items.forEach((item) => {
        var link = item.querySelector('.alia-nav__link');
        var idx = item.getAttribute('data-nav-item');
        var hasPanel = item.getAttribute('data-has-panel') === 'true';

        link.addEventListener('pointerdown', (e) => { this.lastInput = e.pointerType || 'mouse'; }, true);

        if (!hasPanel) {
          item.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && this.openOn === 'hover') { clearTimeout(this.openTimer); this.closeTimer = setTimeout(() => this.close(), 90); } });
          return;
        }

        link.addEventListener('click', (e) => {
          var touch = this.lastInput === 'touch' || this.lastInput === 'pen';
          if (link.hasAttribute('data-noclick')) {          // opens the dropdown, never navigates
            e.preventDefault();
            if (this.current !== item) this.open(item);
            else if (touch || this.openOn === 'click') this.close();
            return;
          }
          if (this.openOn === 'click' || touch) {
            if (this.current === item) return; // second tap follows link
            e.preventDefault();
            this.open(item);
          }
        });
        link.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
            if (e.key !== 'Enter') e.preventDefault();
            this.open(item);
            this.focusFirst();
          }
        });

        var pane = this.panels.filter((p) => p.getAttribute('data-panel') === idx)[0];
        if (pane && pane.getAttribute('data-layout') === 'twopane') this.bindTwoPane(pane);
      });
    }

    bindMegaHover() {
      if (this.openOn !== 'hover') return;
      this.items.forEach((item) => {
        if (item.getAttribute('data-has-panel') !== 'true') return;
        item.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse') return;
          clearTimeout(this.closeTimer); clearTimeout(this.openTimer);
          if (this.current) this.open(item);
          else this.openTimer = setTimeout(() => this.open(item), OPEN_DELAY);
        });
        item.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse') return;
          clearTimeout(this.openTimer);
          this.closeTimer = setTimeout(() => this.close(), CLOSE_DELAY);
        });
      });
      if (this.mega) {
        this.mega.addEventListener('pointerenter', () => clearTimeout(this.closeTimer));
        this.mega.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.closeTimer = setTimeout(() => this.close(), CLOSE_DELAY);
        });
      }
    }

    bindTwoPane(pane) {
      var cats = Array.prototype.slice.call(pane.querySelectorAll('[data-sub]'));
      var subs = Array.prototype.slice.call(pane.querySelectorAll('[data-sub-pane]'));
      if (!cats.length) return;
      var activate = (n) => {
        cats.forEach((c) => c.classList.toggle('is-active', c.getAttribute('data-sub') === n));
        subs.forEach((s) => { var on = s.getAttribute('data-sub-pane') === n; s.classList.toggle('is-active', on); s.hidden = !on; });
        if (this.current) this.setHeight(this.current);
      };
      cats.forEach((c) => {
        var n = c.getAttribute('data-sub');
        c.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') activate(n); });
        c.addEventListener('focus', () => activate(n));
        c.addEventListener('click', () => activate(n));
      });
    }

    paneFor(item) {
      var idx = item.getAttribute('data-nav-item');
      return this.panels.filter((p) => p.getAttribute('data-panel') === idx)[0] || null;
    }

    setHeight(item) {
      var pane = this.paneFor(item);
      if (pane && this.box) this.box.style.height = pane.offsetHeight + 'px';
    }

    // Positions the panel horizontally and points the notch at the item.
    placeBox(item) {
      if (!this.box) return;
      var vw = document.documentElement.clientWidth || window.innerWidth || 0;
      var edge = 24;
      var w = this.box.offsetWidth || Math.max(0, Math.min(1180, vw - edge * 2));
      var link = item.querySelector('.alia-nav__link');
      var r = link.getBoundingClientRect();
      var cx = r.left + r.width / 2;
      var left = (vw - w) / 2;                                   // 'center' mode
      if (this.megaAlign !== 'center') left = Math.max(edge, Math.min(vw - w - edge, cx - w / 2));
      if (!isFinite(left)) left = edge;
      this.box.style.marginLeft = Math.round(left) + 'px';
      if (this.notch) {
        var nx = cx - left;
        var inside = nx >= 28 && nx <= w - 28;
        this.notch.style.setProperty('--alia-notch-x', Math.max(28, Math.min(Math.max(28, w - 28), nx)) + 'px');
        this.notch.style.display = inside ? '' : 'none';
      }
    }

    focusFirst() {
      if (!this.current) return;
      var pane = this.paneFor(this.current);
      var t = pane && pane.querySelector('a[href], button');
      if (t) t.focus({ preventScroll: true });
    }

    open(item) {
      if (this.current === item) return;
      clearTimeout(this.closeTimer); clearTimeout(this.openTimer);
      this.items.forEach((i) => i.classList.toggle('is-open', i === item));

      this.panels.forEach((p) => p.classList.toggle('is-active', p === this.paneFor(item)));
      this.current = item;
      this.hdr.classList.add('is-menu-open');
      this.hdr.classList.remove('is-hidden');
      this.syncTheme();

      var wasOpen = this.mega.classList.contains('is-open');
      this.placeBox(item);
      if (!wasOpen) void this.box.offsetWidth;   // no sideways slide on the very first open
      this.mega.classList.add('is-open');
      this.setHeight(item);
      if (this.scrim) this.scrim.classList.add('is-on');
    }

    close() {
      clearTimeout(this.closeTimer); clearTimeout(this.openTimer);
      if (!this.current) return;
      this.items.forEach((i) => i.classList.remove('is-open'));
      this.current = null;
      this.hdr.classList.remove('is-menu-open');
      if (this.mega) { this.mega.classList.remove('is-open'); this.box.style.height = '0px'; }
      if (this.scrim && !this.drawerOpen) this.scrim.classList.remove('is-on');
    }

    /* ---- search (predictive) ------------------------------------------- */
    bindSearch() {
      if (!this.search) return;
      this.searchToggles = Array.prototype.slice.call(this.sroot.querySelectorAll('[data-search-toggle]'));
      this.searchToggles.forEach((b) => b.addEventListener('click', () => this.openSearch()));
      var close = this.search.querySelector('[data-search-close]');
      if (close) close.addEventListener('click', () => this.closeSearch());

      this.sInput = this.search.querySelector('input[name="q"]');
      this.sResults = this.search.querySelector('[data-results]');
      this.sForm = this.search.querySelector('form');
      this.sReq = 0; this.sTimer = null; this.sCtl = null; this.sIndex = -1;
      if (!this.sInput || !this.sResults) return;

      this.sClear = this.search.querySelector('[data-search-clear]');
      if (this.sClear) this.sClear.addEventListener('click', () => {
        this.sInput.value = ''; this.sInput.focus(); this.onSearchInput();
      });
      this.sInput.addEventListener('input', () => this.onSearchInput());
      this.sInput.addEventListener('keydown', (e) => this.onSearchKey(e));
      this.sForm.addEventListener('submit', (e) => {
        var a = this.activeResult();
        if (a && a.getAttribute('href')) { e.preventDefault(); window.location.assign(a.getAttribute('href')); }
      });
    }
    openSearch() {
      this.close();
      this.searchOpen = true;
      this.search.classList.add('is-open');
      document.body.classList.add('alia-search-open');
      if (this.scrim) this.scrim.classList.add('is-on');
      var input = this.search.querySelector('input[name="q"]');
      if (input) setTimeout(() => { input.focus(); input.select && input.select(); }, 60);
    }
    closeSearch() {
      if (!this.searchOpen && !(this.search && this.search.classList.contains('is-open'))) return;
      this.searchOpen = false;
      if (this.search) this.search.classList.remove('is-open');
      document.body.classList.remove('alia-search-open');
      clearTimeout(this.sTimer);
      if (this.sCtl && this.sCtl.abort) this.sCtl.abort();
      if (this.scrim && !this.drawerOpen && !this.current) this.scrim.classList.remove('is-on');
    }

    onSearchInput() {
      if (this.sClear) this.sClear.hidden = !this.sInput.value;
      var q = this.sInput.value.trim();
      clearTimeout(this.sTimer);
      this.sIndex = -1;
      if (q.length < 2) { this.sReq++; this.resetSearch(); return; }
      if (this.sResults.hidden || !this.sResults.innerHTML) this.showLoading();
      this.sTimer = setTimeout(() => this.runSearch(q), 220);
    }

    runSearch(q) {
      if (this.sCtl && this.sCtl.abort) this.sCtl.abort();
      this.sCtl = typeof AbortController === 'function' ? new AbortController() : null;
      var id = ++this.sReq;
      var d = this.search.dataset;
      var types = d.types === 'product' ? 'product' : 'product,collection,page,article,query';
      var url = (d.predictiveUrl || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=' + types +
        '&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,vendor,tag,variants.title,variants.sku';
      var opts = { headers: { Accept: 'application/json' } };
      if (this.sCtl) opts.signal = this.sCtl.signal;
      fetch(url, opts)
        .then((r) => { if (!r.ok) throw new Error('search ' + r.status); return r.json(); })
        .then((data) => {
          if (id !== this.sReq) return;
          this.renderResults(q, (data && data.resources && data.resources.results) || {});
        })
        .catch((err) => {
          if (err && err.name === 'AbortError') return;
          if (id !== this.sReq) return;
          this.renderResults(q, null);          // fall back to a plain "see all results" link
        });
    }

    esc(v) {
      return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    money(v) {
      var n = parseFloat(v);
      if (!isFinite(n)) return '';
      var d = this.search.dataset;
      var whole = n % 1 === 0;   // "$3,300" like the storefront, but "$19.50" when there are cents
      try {
        return new Intl.NumberFormat(d.locale || undefined, {
          style: 'currency', currency: d.currency || 'AUD', currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
        }).format(n);
      } catch (e) { return '$' + (whole ? n.toFixed(0) : n.toFixed(2)); }
    }
    arrowSvg() { return '<svg viewBox="0 0 14 14" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h8M7.5 3.5 11 7l-3.5 3.5"/></svg>'; }

    renderResults(q, res) {
      var esc = (v) => this.esc(v);
      var d = this.search.dataset;
      var allUrl = (d.searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      var html = '';
      var products = (res && res.products) || [], cols = (res && res.collections) || [],
          pages = (res && res.pages) || [], arts = (res && res.articles) || [], queries = (res && res.queries) || [];
      var total = products.length + cols.length + pages.length + arts.length + queries.length;

      if (res && !total) {
        html = '<p class="alia-sr-empty">No results for \u201c' + esc(q) + '\u201d. Try a different word, or browse the popular links.</p>';
      } else {
        if (queries.length) {
          html += '<div class="alia-sr-group"><span class="alia-search__label">Suggestions</span><div class="alia-sr-list">' +
            queries.map((x) => '<a class="alia-sr-link" data-result role="option" href="' + esc(x.url) + '">' + this.searchIcon() + '<span>' + esc(x.text) + '</span></a>').join('') + '</div></div>';
        }
        if (products.length) {
          html += '<div class="alia-sr-group"><span class="alia-search__label">Products</span><div class="alia-sr-grid">' +
            products.map((p) => {
              var img = p.image || (p.featured_image && p.featured_image.url) || '';
              if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=128';
              var pmin = p.price_min != null ? p.price_min : p.price, pmax = p.price_max != null ? p.price_max : p.price;
              var price = (pmin != null && pmax != null && parseFloat(pmin) !== parseFloat(pmax)) ? 'From ' + this.money(pmin) : this.money(pmin != null ? pmin : p.price);
              var sold = p.available === false ? '<span class="alia-sr-tag">Sold out</span>' : '';
              return '<a class="alia-sr-product" data-result role="option" href="' + esc(p.url) + '">' +
                (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="alia-sr-ph"></span>') +
                '<span><span class="alia-sr-title">' + esc(p.title) + '</span><span class="alia-sr-price">' + esc(price) + sold + '</span></span></a>';
            }).join('') + '</div></div>';
        }
        var links = function (label, arr) {
          if (!arr.length) return '';
          return '<div class="alia-sr-group"><span class="alia-search__label">' + label + '</span><div class="alia-sr-list">' +
            arr.map((x) => '<a class="alia-sr-link" data-result role="option" href="' + esc(x.url) + '"><span>' + esc(x.title) + '</span></a>').join('') + '</div></div>';
        };
        html += links('Collections', cols) + links('Guides & pages', pages.concat(arts));
        html += '<a class="alia-sr-all" data-result role="option" href="' + esc(allUrl) + '"><span>See all results for \u201c' + esc(q) + '\u201d</span>' + this.arrowSvg() + '</a>';
      }
      this.sResults.innerHTML = html;
      this.sResults.hidden = false;
      this.search.classList.add('has-results');
      if (this.sInput) this.sInput.setAttribute('aria-expanded', 'true');
      this.sIndex = -1;
    }
    searchIcon() { return '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2"/></svg>'; }

    showLoading() {
      this.sResults.innerHTML = '<div class="alia-sr-skel" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i></div>';
      this.sResults.hidden = false;
      this.search.classList.add('has-results');
    }
    resetSearch() {
      if (!this.sResults) return;
      this.sResults.hidden = true;
      this.sResults.innerHTML = '';
      this.search.classList.remove('has-results');
      if (this.sInput) this.sInput.setAttribute('aria-expanded', 'false');
    }
    resultItems() { return this.sResults ? Array.prototype.slice.call(this.sResults.querySelectorAll('[data-result]')) : []; }
    activeResult() { var i = this.resultItems(); return this.sIndex > -1 ? i[this.sIndex] || null : null; }
    onSearchKey(e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var items = this.resultItems();
      if (!items.length) return;
      e.preventDefault();
      var n = items.length;
      this.sIndex = e.key === 'ArrowDown' ? (this.sIndex + 1) % n : (this.sIndex - 1 + n) % n;
      items.forEach((el, i) => {
        el.classList.toggle('is-active', i === this.sIndex);
        el.setAttribute('aria-selected', i === this.sIndex ? 'true' : 'false');
      });
      var a = items[this.sIndex];
      if (a && a.scrollIntoView) a.scrollIntoView({ block: 'nearest' });
    }

    /* ---- mobile drawer + accordion ------------------------------------- */
    bindDrawer() {
      this.burger = this.sroot.querySelector('[data-burger]');
      if (this.burger) this.burger.addEventListener('click', () => this.toggleDrawer());
      if (!this.drawer) return;
      var close = this.drawer.querySelector('[data-drawer-close]');
      if (close) close.addEventListener('click', () => this.closeDrawer());

      this.accordions = Array.prototype.slice.call(this.drawer.querySelectorAll('[data-macc]'));
      this.accordions.forEach((acc) => {
        var toggle = acc.querySelector('[data-macc-toggle]');
        var sub = acc.querySelector('[data-macc-sub]');
        if (!toggle || !sub) return;
        toggle.addEventListener('click', () => {
          var open = acc.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          sub.style.height = open ? sub.firstElementChild.offsetHeight + 'px' : '0px';
        });
      });
      // Close the drawer when a real navigation link is tapped
      this.drawer.addEventListener('click', (e) => {
        var a = e.target.closest('a[href]');
        if (a && !a.hasAttribute('data-macc-keep')) this.closeDrawer();
      });
    }
    toggleDrawer() { this.drawerOpen ? this.closeDrawer() : this.openDrawer(); }
    openDrawer() {
      this.close();
      this.drawerOpen = true;
      this.drawer.classList.add('is-open');
      document.body.classList.add('alia-drawer-open');
      if (this.burger) this.burger.setAttribute('aria-expanded', 'true');
    }
    closeDrawer() {
      this.drawerOpen = false;
      if (this.drawer) this.drawer.classList.remove('is-open');
      document.body.classList.remove('alia-drawer-open');
      if (this.scrim && !this.current && !this.searchOpen) this.scrim.classList.remove('is-on');
      if (this.burger) this.burger.setAttribute('aria-expanded', 'false');
    }

    /* ---- cart badge ---------------------------------------------------- */
    syncCart() {
      var badges = Array.prototype.slice.call(this.sroot.querySelectorAll('[data-cart-count]'));
      if (!badges.length) return;
      var set = (n) => badges.forEach((b) => { b.textContent = n > 99 ? '99+' : String(n); b.hidden = n === 0; });
      if (typeof fetch === 'function') {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then((r) => r.ok ? r.json() : null)
          .then((c) => { if (c && typeof c.item_count === 'number') set(c.item_count); })
          .catch(function () {});
      }
      document.addEventListener('cart:updated', (e) => { if (e.detail && typeof e.detail.item_count === 'number') set(e.detail.item_count); });
    }
  }

  customElements.define('alia-header', AliaHeader);
})();
